module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAPklEQVQ4jWNgGGjAyMDAwHBOUO0/OZqN3t9iZKLUBaMGQMGmTZv+kwo2bdr0nyouGHgDWGCMzZs3U2rWUAUAu6A8KU4aE6MAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/ID.png
// module id = 1165
// module chunks = 0